import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import translateMapsServices from '@src/services/translateMaps.services';

export const getByKeys = createAsyncThunk(
  'translateMap/getByKeys',
  async (keys, { rejectWithValue }) => {
    try {
      return await translateMapsServices.getByKeys(keys);
    } catch (error) {
      return rejectWithValue(error?.data);
    }
  },
);

export const translateMapSlice = createSlice({
  name: 'translateMap',
  initialState: {
    translateMap: {},
  },
  reducers: {},
  extraReducers: (builder) => {
    builder.addCase(getByKeys.fulfilled, (state, action) => {
      state.translateMap = action.payload.data.data || {};
    });
  },
});
